import { Link } from "react-router-dom";
import {
  formatUploadArticleDateTime,
  getUploadArticleRecordTimestamp,
} from "../../../utils/uploadArticlesDateUtils";

export default function UploadArticlesTable({
  loadedArticles,
  selectedArticles,
  getArticleKey,
  isArticleSelectable,
  handleSelectAll,
  handleSelectArticle,
  getCategoryName,
  selectAllRef,
  isAllSelected,
  isIndeterminate = false,
  selectAllDisabled = false,
  selectAllLoading = false,
  processingArticles,
  pagination,
}) {
  const totalPages =
    pagination && pagination.totalItems > 0
      ? Math.ceil(pagination.totalItems / pagination.pageSize)
      : 1;
  const showPagination =
    pagination && pagination.totalItems > pagination.pageSize;

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full bg-white border border-gray-200 rounded-lg">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-6 py-3 border-b border-gray-200 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-12">
              <input
                type="checkbox"
                ref={selectAllRef}
                checked={isAllSelected}
                disabled={selectAllDisabled}
                title={
                  selectAllLoading
                    ? "Cargando selección de todos los artículos del filtro"
                    : "Seleccionar todos los artículos publicables del filtro activo"
                }
                onChange={handleSelectAll}
                className="rounded border-gray-300 text-primary-600 focus:ring-primary-500 disabled:opacity-50 disabled:cursor-not-allowed"
              />
            </th>
            <th className="px-6 py-3 border-b border-gray-200 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              ASIN
            </th>
            <th className="px-6 py-3 border-b border-gray-200 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              ML Product ID
            </th>
            <th className="px-6 py-3 border-b border-gray-200 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Título
            </th>
            <th className="px-6 py-3 border-b border-gray-200 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Precio
            </th>
            <th className="px-6 py-3 border-b border-gray-200 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Fecha registro
            </th>
            <th className="px-6 py-3 border-b border-gray-200 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Precio Calculado
            </th>
            <th className="px-6 py-3 border-b border-gray-200 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Peso
            </th>
            <th className="px-6 py-3 border-b border-gray-200 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Categoría
            </th>
            <th className="px-6 py-3 border-b border-gray-200 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Nombre
            </th>
            <th className="px-6 py-3 border-b border-gray-200 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Estado
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200">
          {loadedArticles.map((article, index) => {
            const articleKey = getArticleKey(article);
            const processingState = processingArticles.get(article.id);
            const isProcessing =
              processingState &&
              processingState.status !== "completed" &&
              processingState.status !== "error" &&
              processingState.status !== "cancelled";
            const canSelect =
              articleKey && isArticleSelectable(article) && !isProcessing;

            return (
              <tr
                key={`${articleKey ?? "article"}-${index}`}
                className={`hover:bg-gray-50 ${
                  isProcessing ? "bg-blue-50" : article.price === 0 ? "bg-yellow-50" : article.price === null ? "bg-red-50" : ""
                }`}
              >
                <td className="px-6 py-4 whitespace-nowrap">
                  {canSelect && (
                    <input
                      type="checkbox"
                      checked={selectedArticles.has(articleKey)}
                      onChange={() => handleSelectArticle(article)}
                      className="rounded border-gray-300 text-primary-600 focus:ring-primary-500"
                    />
                  )}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {article.asin ? <a href={`https://www.amazon.com/dp/${article.asin}`} target="_blank">{article.asin}</a> : "N/A"}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {article.ml_product_id ? <a href={`https://www.mercadolibre.com.uy/p/${article.ml_product_id}`} target="_blank">{article.ml_product_id}</a> : "N/A"}
                </td>
                <td
                  className="px-6 py-4 text-sm text-gray-900 max-w-xs truncate"
                  title={article.title}
                >
                  {article.title || "N/A"}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {article.price ? `$${article.price}` : "N/A"}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 tabular-nums">
                  {formatUploadArticleDateTime(
                    getUploadArticleRecordTimestamp(article)
                  ) ?? "N/A"}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {article.calculated_price
                    ? `$${article.calculated_price.toLocaleString()}`
                    : "N/A"}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {article.weight ? `${article.weight}grs.` : "N/D"}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {article.category_id || "N/A"}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {getCategoryName(article)}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {processingState &&
                  processingState.status !== "completed" &&
                  processingState.status !== "error" &&
                  processingState.status !== "cancelled" ? (
                    <div className="flex flex-col gap-1">
                      <div className="w-full bg-gray-200 rounded-full h-2">
                        <div
                          className={`h-2 rounded-full transition-all duration-300 ${
                            processingState.status === "processing"
                              ? "bg-blue-600"
                              : "bg-gray-400"
                          }`}
                          style={{ width: `${processingState.progress}%` }}
                        ></div>
                      </div>
                      <span className="text-xs text-blue-600">
                        {processingState.status === "processing"
                          ? "Publicando..."
                          : "Pendiente"}
                      </span>
                    </div>
                  ) : processingState &&
                    processingState.status === "error" ? (
                    <span className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-red-200 text-red-700">
                      Error
                    </span>
                  ) : processingState &&
                    processingState.status === "cancelled" ? (
                    <span className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-amber-100 text-amber-800">
                      Cancelado
                    </span>
                  ) : (
                    <span
                      className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                        article.status
                          ? "bg-green-100 text-green-800"
                          : "bg-red-200 text-red-700"
                      }`}
                    >
                      {article.status ? "Procesado" : "Pendiente"}
                    </span>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      {showPagination && (
        <div className="flex flex-wrap items-center justify-between gap-3 mt-4 px-1">
          <p className="text-sm text-gray-600">
            Mostrando{" "}
            {(pagination.currentPage - 1) * pagination.pageSize + 1}–
            {Math.min(
              pagination.currentPage * pagination.pageSize,
              pagination.totalItems
            )}{" "}
            de {pagination.totalItems}
          </p>
          <div className="flex flex-wrap items-center gap-2">
            <button
              type="button"
              disabled={pagination.currentPage <= 1}
              onClick={() => pagination.onPageChange(1)}
              className="px-3 py-1.5 text-sm rounded-md border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Primera
            </button>
            <button
              type="button"
              disabled={pagination.currentPage <= 1}
              onClick={() =>
                pagination.onPageChange((p) => Math.max(1, p - 1))
              }
              className="px-3 py-1.5 text-sm rounded-md border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Anterior
            </button>
            <span className="text-sm text-gray-700 tabular-nums px-1">
              Página {pagination.currentPage} de {totalPages}
            </span>
            <button
              type="button"
              disabled={pagination.currentPage >= totalPages}
              onClick={() =>
                pagination.onPageChange((p) =>
                  Math.min(totalPages, p + 1)
                )
              }
              className="px-3 py-1.5 text-sm rounded-md border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Siguiente
            </button>
            <button
              type="button"
              disabled={pagination.currentPage >= totalPages}
              onClick={() => pagination.onPageChange(totalPages)}
              className="px-3 py-1.5 text-sm rounded-md border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Última
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
